<template>
    <div>
        <gofix-default-table
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="createDepartmentModal"
                @row-click="goToDetail"
                @delete-items="deleteItems"
                ref="gofixTable">
            <template slot="gofix_table:created_at" slot-scope="row">
                {{ row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="models.title" hide-footer :centered="true" v-model="models.open" @hidden="hiddenModel">
            <b-form class="pb-20">
                <gofix-form-properties
                        label="Property"
                        :contract-id="$route.params.id"
                        valueFormat="object"
                        v-model="models.data.property"
                        search-nested>
                </gofix-form-properties>
                <gofix-form-dropdown
                    label="Department Code"
                    :filterable="false"
                    :clearable="true"
                    :required="false"
                    v-model="models.data.dept_code"
                    vLabel="source_code"
                    :reduce="option => option.source_code"
                    :options="departmentCodeOptions"
                    @search="loadDepartmentCode">
                    <template #gofixInput:dropdown:option="{ source_description, source_code }">
                         {{ source_description }} {{ (source_description ? "/" : "")}} {{ source_code }}
                    </template>
                    <template #gofixInput:dropdown:selected-option="{ source_description, source_code }">
                        {{ source_description }} {{ (source_description ? "/" : "")}} {{ source_code }}
                    </template>
                </gofix-form-dropdown>
                <gofix-form-dropdown
                    label="Debtor Code"
                    :filterable="false"
                    :clearable="true"
                    :required="false"
                    v-model="models.data.debtor_code"
                    vLabel="source_code"
                    :reduce="option => option.source_code"
                    :options="debtorCodeOptions"
                    @search="loadDebtorCode">
                    <template #gofixInput:dropdown:option="{ source_description, source_code }">
                         {{ source_description }} {{ (source_description ? "/" : "")}} {{ source_code }}
                    </template>
                    <template #gofixInput:dropdown:selected-option="{ source_description, source_code }">
                        {{ source_description }} {{ (source_description ? "/" : "")}} {{ source_code }}
                    </template>
                </gofix-form-dropdown>
                <!--<gofix-form-input label="Department Code" v-model="models.data.dept_code"></gofix-form-input>
                <gofix-form-input label="Debtor Code" v-model="models.data.debtor_code"></gofix-form-input>-->
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="createDepartment" :loading="models.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'fm-codes',
        components: {},
        data () {
            let filterDepartmentCode = JSON.parse(JSON.stringify(filters['department_code']));
            return {
                tableConfig:{
                    name: 'finance-department-code-and-debtor-code',
                    controls:{
                        create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                        createTooptip:"Assign Department & Debtor Code",
                        delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete'),
                        tableExport: false
                    },
                    filter: filterDepartmentCode,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "name",
                    sortDirection: "asc",
                    itemSelected: [],
                },
                tableItems:[],
                models:{
                    open: false,
                    loading: false,
                    title:"Assign Department & Debtor Code",
                    data:{
                        id: null,
                        dept_code: null,
                        property_id: null,
                        property: null,
                        client_contract_id: this.$route.params.id,
                        debtor_code: null,
                    },
                    properties : {
                        data: [],
                        loading: false
                    }
                },
                departmentCodeOptions:[],
                debtorCodeOptions:[],
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles',
            }),
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                    createTooptip:"Create Department Code",
                    delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete')
                }
            },
            "ClientContractID.id" : function(val,old){
                if(old && old !== val){
                    if(val){
                        this.loadproperty(val);
                        this.models.data.client_contract_id = val;
                    }else{
                        return this.$router.push('/v2/contract-client')
                    }
                }
            }
        },
        created() {},
        methods:{
            async createDepartmentModal(){
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                this.loadDepartmentCode();
                this.loadDebtorCode();
                this.models.open = true
            },
            /*---------------------Fm code------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("PropertyDepartmentController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load items", "danger");
                        reject();
                    })
            },
            goToDetail(item){
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                this.loadDepartmentCode();
                this.loadDebtorCode();
                this.models.title = 'Assign Department & Debtor Code';
                this.models.data = Object.assign({}, {
                    id: item.id,
                    property_id: item.property_id,
                    property: {
                        id: item.property_id,
                        name: item.name,
                    },
                    dept_code: item.dept_code,
                    debtor_code: item.debtor_code,
                    client_contract_id: this.$route.params.id,
                });
                this.models.open = true;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PropertyDepartmentController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'department_code'))
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            createDepartment(){
                if (!this.models.data.dept_code) {
                    return this.$alertNotification("Department code is a required field.", "danger");
                }
                if (!this.models.data.property) {
                    return this.$alertNotification("Property is a required field.", "danger");
                }

                this.models.data.property_id = this.models.data.property  ? this.models.data.property.id : null;

                let action = "createItem"
                let keyMessage= 'adding'
                if(this.models.data.id){
                    action = "updateItem"
                    keyMessage = 'editing'
                }

                this.models.loading = true;
                this.$store.dispatch(`PropertyDepartmentController/${action}`, this.models.data)
                    .then(result => {
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'department_code'));
                        this.models.loading = false;
                        this.models.open = false;
                    })
                    .catch(error => {
                        this.models.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) return this.$alertNotification(error.response.data.error.message.error, "danger");
                            this.$alertNotification("Error", "danger");
                        }
                    })
            },
            loadDepartmentCode(search = null){
                let filter = {
                    source_type: "D",
                    is_blocked: 0,
                    source_code: search || null,
                    contract_id: this.$route.params.id ? this.$route.params.id : null,
                };
                let params = {
                  filter: filter,
                  limit: 50,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.departmentCodeOptions = response.items;
                    })
            },
            loadDebtorCode(search = null){
                let filter = {
                    source_type: "C",
                    is_blocked: 0,
                    source_code: search || null,
                    contract_id: this.$route.params.id ? this.$route.params.id : null,
                };
                let params = {
                  filter: filter,
                  limit: 50,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.debtorCodeOptions = response.items;
                    })
            },

            /*---- Load data -----------------------*/

            loadproperty(val){
                this.models.properties.loading = true;
                this.$store.dispatch('FmCodeController/getProperties', {
                    contractId: val || this.$route.params.id,
                    propertyId: 0
                }).then(response => {
                    this.models.properties.loading = false;
                    this.models.properties.data = response;
                })
                    .catch(err => {
                        console.log(err);
                        this.models.properties.loading = false;
                        this.models.properties.data = [];
                    });
            },


            /*---- Models -----------------------*/
            hiddenModel(){
                this.models.title = "Assign Department & Debtor Code";
                this.models.data = {
                    id: null,
                    property_id: null,
                    property: null,
                    dept_code: null,
                    client_contract_id: this.$route.params.id,
                }
            },
        }
    }
</script>
